import Ajv from 'ajv';

import { isNotEmpty } from '../keywords';

const ajv = new Ajv({ allErrors: true, verbose: true, coerceTypes: true, useDefaults: true });

ajv.addKeyword('isNotEmpty', isNotEmpty);

export default ajv;
